import React from "react";
import PropTypes from "prop-types";

const ApiFormField = ({ name, options, value, onChange, relationOptions }) => {
  const label = options?.string || name;
  const required = Boolean(options?.required);
  const type = options?.type || "char";

  const labelEl = (
    <label className="form-field-label" htmlFor={name}>
      {label}
      {required ? <span className="req-star">*</span> : null}
    </label>
  );

  let input = null;

  if (type === "boolean") {
    input = (
      <div className="form-field-check">
        <input
          id={name}
          name={name}
          type="checkbox"
          required={required}
          checked={Boolean(value)}
          onChange={(e) => onChange(name, e.target.checked, type)}
        />
        <span style={{ color: "var(--text-secondary)", fontSize: "0.88rem" }}>{label}</span>
      </div>
    );
    return <div className="form-field">{input}</div>;
  }

  if (type === "selection") {
    input = (
      <select
        id={name}
        name={name}
        className="form-control"
        required={required}
        value={value || ""}
        onChange={(e) => onChange(name, e.target.value, type)}>
        <option value="">{label}</option>
        {(options.selection || []).map(([key, optLabel]) => (
          <option key={key} value={key}>
            {optLabel}
          </option>
        ))}
      </select>
    );
  } else if (type === "one2one" || type === "many2one") {
    const selected =
      (Array.isArray(value) ? [...value].shift() : value) || "";
    input = (
      <select
        id={name}
        name={name}
        className="form-control"
        required={required}
        value={selected}
        onChange={(e) => onChange(name, e.target.value, type)}>
        <option value="">{label}</option>
        {(relationOptions || []).map(([key, optLabel]) => (
          <option key={key} value={key}>
            {optLabel}
          </option>
        ))}
      </select>
    );
  } else if (type === "one2many" || type === "many2many") {
    input = (
      <select
        multiple
        id={name}
        name={name}
        className="form-control"
        required={required}
        value={value || []}
        onChange={(e) => {
          const selected = Array.from(e.target.selectedOptions).map((o) => o.value);
          onChange(name, selected, type);
        }}>
        {(relationOptions || []).map(([key, optLabel]) => (
          <option key={key} value={key}>
            {optLabel}
          </option>
        ))}
      </select>
    );
  } else if (type === "datetime") {
    input = (
      <input
        id={name}
        name={name}
        className="form-control"
        type="datetime-local"
        required={required}
        placeholder={label}
        value={value || ""}
        onChange={(e) => onChange(name, e.target.value, type)}
      />
    );
  } else if (type === "date") {
    input = (
      <input
        id={name}
        name={name}
        className="form-control"
        type="date"
        required={required}
        placeholder={label}
        value={value || ""}
        onChange={(e) => onChange(name, e.target.value, type)}
      />
    );
  } else if (type === "float") {
    input = (
      <input
        id={name}
        name={name}
        className="form-control"
        type="number"
        step="0.01"
        required={required}
        placeholder={label}
        value={value ?? ""}
        onChange={(e) => onChange(name, e.target.value, type)}
      />
    );
  } else if (type === "integer") {
    input = (
      <input
        id={name}
        name={name}
        className="form-control"
        type="number"
        required={required}
        placeholder={label}
        value={value ?? ""}
        onChange={(e) => onChange(name, e.target.value, type)}
      />
    );
  } else if (type === "binary") {
    input = (
      <input
        id={name}
        name={name}
        className="form-control"
        type="file"
        required={required}
        onChange={(e) => onChange(name, e.target.value, type)}
      />
    );
  } else {
    input = (
      <input
        id={name}
        name={name}
        className="form-control"
        type="text"
        required={required}
        placeholder={label}
        value={value ?? ""}
        onChange={(e) => onChange(name, e.target.value, type)}
      />
    );
  }

  return (
    <div className="form-field">
      {labelEl}
      {input}
    </div>
  );
};

ApiFormField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  relationOptions: PropTypes.array
};

ApiFormField.defaultProps = {
  value: "",
  relationOptions: []
};

export default ApiFormField;
